import { render, staticRenderFns } from "./SurveyStatisticsView.vue?vue&type=template&id=5b493be8"
import script from "./SurveyStatisticsView.ts?vue&type=script&lang=ts&external"
export * from "./SurveyStatisticsView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports